import { useFormContext, useWatch } from "react-hook-form";

export default function DedicatedCsmConfig({
  inputClasses,
}) {
  const { register, setValue } = useFormContext();
  const dedicatedCsm = useWatch({ name: "dedicatedCsm" });

  return (
    <div>
      <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-4">
        <div className="flex items-center">
          <input
            {...register("dedicatedCsm.enabled")}
            id="dedicated-csm-enabled"
            name="dedicated-csm-enabled"
            type="checkbox"
            checked={dedicatedCsm.enabled}
            onChange={(e) => setValue("dedicatedCsm.enabled", e.target.checked, { shouldDirty: true })
            }
            className="h-5 w-5 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
          />
          <label
            htmlFor="dedicated-csm-enabled"
            className="ml-3 text-sm font-semibold text-gray-900"
          >
            Include dedicated CSM in subscription
          </label>
        </div>
      </div>

      {dedicatedCsm.enabled ? (
        <div className="pt-4 border-t border-gray-200">
          <div className="flex items-center justify-between mb-3">
            <label className="block text-sm font-medium text-gray-900">Custom CSM pricing</label>
            <div className="flex items-center">
              <input
                {...register("dedicatedCsm.hasCustomPricing")}
                id="dedicated-csm-custom-pricing"
                type="checkbox"
                checked={dedicatedCsm.hasCustomPricing}
                onChange={(e) => setValue("dedicatedCsm.hasCustomPricing", e.target.checked, { shouldDirty: true })
                }
                className="h-4 w-4 rounded border-gray-300 text-gray-900 focus:ring-gray-900"
              />
              <label
                htmlFor="dedicated-csm-custom-pricing"
                className="ml-2 text-sm font-medium text-gray-700"
              >
                Enable custom CSM pricing
              </label>
            </div>
          </div>

          {dedicatedCsm.hasCustomPricing ? (
            <div>
              <div className="relative">
                <span className="absolute left-3.5 top-1/2 -translate-y-1/2 text-gray-500 text-sm">
                  $
                </span>
                <input
                  {...register("dedicatedCsm.dollars", {
                    valueAsNumber: true,
                  })}
                  id="dedicated-csm-dollars"
                  type="number"
                  step="0.01"
                  min="0"
                  className={`${inputClasses} pl-7`}
                  placeholder="0.00"
                />
              </div>
            </div>
          ) : (
            <div className="bg-gray-50 border border-gray-200 rounded-lg p-4">
              <p className="text-sm text-gray-600">
                Using server default pricing for dedicated CSM
              </p>
            </div>
          )}
        </div>
      ) : (
        <div className="bg-gray-50 border border-gray-200 rounded-lg p-4">
          <p className="text-sm text-gray-600">
            Dedicated CSM is currently excluded.
          </p>
        </div>
      )}
    </div>
  );
}
